import { Box, Stack, styled } from "@mui/material"

export const Section = styled(Stack)(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '32px',
    padding: '48px 96px',
    flexWrap:'wrap',
    minHeight:' 80vh',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 6px',
    },
}))
export const RightSection = styled(Box)(({ theme }) => (props) => ({
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    borderRight: '1px solid #E2e2e2',
    [theme.breakpoints.down('lg')]: {
        width: '60%'
    },
    [theme.breakpoints.down('md')]: {
        width: '100%'
    }
}))
export const LeftSection = styled(Box)(({ theme }) => (props) => ({
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('lg')]: {
        width: '35%'
    },
    [theme.breakpoints.down('md')]: {
        width: '100%'
    }
}))